import { useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import Cover from "../../components/Cover";
import Figure from "../../components/Figure";
import StoryDate from "../../components/StoryDate";
import MoreStory from "../../components/MoreStory";
import Invite from "../../components/Invite";
import Conclusion from "../../components/Conclusion";
import Quote from "../../components/Quote";
import Test from "../../components/Test";
import styles from "./StoryEkaterina.module.scss";
import clsx from "clsx";

const StoryEkaterina = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const refContruction = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 1);

    const wrap = refContruction.current;

    let options = {
      threshold: 0,
      rootMargin: "0% 0% 0% 0%",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(wrap);

    return () => {
      observer.unobserve(wrap);
    };
  }, []);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover}>
          <Cover
            className={styles.cover__inner}
            classNameText={styles.cover__text}
            img="ekaterina-img"
            name="Екатерина Репкина"
            position="Директор департамента подготовки кадров"
            text={
              isMobile
                ? [
                    "Привет! Моя карьера в Р-Фарм ― линейная, но уникальная с точки зрения развития компетенций",
                    "Я стояла у истоков первого производственного проекта\n и участвовала в создании системы подготовки кадров для группы компаний. Это очень интересный и ценный опыт.",
                  ]
                : [
                    "Привет! Моя карьера в Р-Фарм ― линейная, \nно уникальная с точки зрения развития компетенций",
                    "Я стояла у истоков первого производственного проекта и участвовала в создании системы подготовки кадров для группы компаний. Это очень интересный и ценный опыт.",
                  ]
            }
          >
            <div className={styles.constructions} ref={refContruction}>
              <div className={styles.constructions__row}>
                <div className={clsx(styles.construct, styles.construct_1)}>
                  <Figure
                    className={clsx(styles.construct, styles.construct_1)}
                    bg="green-saw.svg"
                  />
                </div>
                <div className={clsx(styles.construct, styles.construct_2)}>
                  <Figure color="green-dark" form="rect">
                    <div className={styles.construct__text}>энтузиазм</div>
                  </Figure>
                </div>
                <div className={clsx(styles.construct, styles.construct_3)}>
                  <Figure bg="green-triangle.svg" />
                </div>
                <div className={clsx(styles.construct, styles.construct_4)}>
                  <Figure
                    bg={
                      isMobile
                        ? "white-saw-ekaterina.svg"
                        : "transparent-saw-ekaterina.svg"
                    }
                  >
                    <div className={styles.construct__text}>с нуля</div>
                  </Figure>
                </div>
              </div>

              <div className={styles.constructions__row}>
                <div className={clsx(styles.construct, styles.construct_5)}>
                  <Figure color="green-secondary" form="rect">
                    <div className={styles.construct__text}>
                      движение вперёд
                    </div>
                  </Figure>
                </div>
                <div className={clsx(styles.construct, styles.construct_6)}>
                  <Figure bg="ellipse-in-rounded-rectangle.svg" />
                </div>
              </div>
            </div>
          </Cover>
        </div>

        <section className={styles.storyStage} data-stage="0">
          <div className={clsx("container", styles.storyStage__inner)}>
            <div>
              <StoryDate
                className={styles.storyStage__date}
                date="2013 год"
                title={"У истоков первого\nпроизводственного\nпроекта"}
                color="green-light-secondary"
              />
              {isMobile ? (
                <p
                  className={styles.storyStage__intro}
                  data-animate="fade-in-up"
                >
                  Когда в 2010 году меня пригласили <br />
                  на работу в Р-Фарм, перед первым собеседованием мне пришлось
                  искать информацию в интернете. Тогда <br />о компании почти
                  никто не знал.
                  <br />
                  <br />
                  На тот момент я работала <br />в железнодорожной коммерческой
                  компании, где уже выстроила HR-процессы, и мне было интересно
                  сделать ещё что-то с нуля в другой отрасли. <br />
                  Р-Фарм показался подходящим вариантом.
                </p>
              ) : (
                <p
                  className={styles.storyStage__intro}
                  data-animate="fade-in-up"
                >
                  Когда в 2010 году меня пригласили на работу в Р-Фарм, перед
                  первым собеседованием мне пришлось искать информацию
                  <br />
                  в интернете. Тогда о компании почти никто не знал.
                  <br />
                  <br />
                  На тот момент я работала в железнодорожной коммерческой
                  компании, где уже выстроила HR-процессы, и мне было интересно
                  сделать ещё что-то с нуля в другой отрасли. Р-Фарм показался
                  подходящим вариантом.
                </p>
              )}
            </div>

            <Quote
              className={styles.storyStage__quote}
              text={[
                "Истории о том, как интересно начинать всё",
                "с нуля, я слышу от коллег довольно часто. Видимо,",
                "Р-Фарм привлекает именно таких энтузиастов,",
                "самостоятельных и смелых",
              ]}
              textMobile={[
                "Истории о том, как интересно",
                "начинать всё с нуля, я слышу",
                "от коллег довольно часто.",
                "Видимо, Р-Фарм привлекает",
                "именно таких энтузиастов,",
                "самостоятельных и смелых",
              ]}
              color="dark"
            />

            <div
              className={styles.storyStage__detail}
              data-animate="fade-in-up"
            >
              {!isMobile && (
                <img
                  className={styles.storyStage__img1}
                  src={`${path}/img/ekaterina-illustration-1.webp`}
                  alt="иллюстрация"
                />
              )}

              <div className={styles.storyStage__description1}>
                <h3 className={styles.storyStage__title}>
                  Первый завод и первая команда
                </h3>

                {isMobile ? (
                  <p className={styles.storyStage__text}>
                    Я стала руководителем отдела персонала в Ярославле. Нужно
                    было организовать кадровое обеспечение всех бизнес-задач
                    региона. Строился первый инновационный завод, который в
                    итоге стал самым большим в группе компаний. <br />Я горжусь, что
                    стояла у истоков проекта
                    <br /> и собирала первую производственную команду.
                  </p>
                ) : (
                  <p className={styles.storyStage__text}>
                    Я стала руководителем отдела персонала в Ярославле. Нужно
                    было организовать кадровое обеспечение всех бизнес-задач
                    региона. Строился первый инновационный завод, который в
                    итоге стал самым большим в группе компаний. Я горжусь, что
                    стояла у истоков проекта и собирала первую производственную
                    команду.
                  </p>
                )}
                <p className={styles.storyStage__text}>
                  Мы вместе с HR центрального офиса занимались рекрутингом,
                  графиками, охраной труда, обучением и развитием.
                  <br />
                  Всё выстраивалось с нуля ― и эти процессы потом стали эталоном
                  для других площадок.
                </p>
                {isMobile && (
                  <img
                    className={styles.storyStage__img1}
                    src={`${path}/img/ekaterina-illustration-1.webp`}
                    alt="иллюстрация"
                  />
                )}
                {isMobile ? (
                  <p className={styles.storyStage__text}>
                    Задачи выходили за рамки одного производства: офис компании
                    <br />
                    в Ярославле, завод «ОРТАТ» <br />в Костромской области,
                    площадка
                    <br />в Ростове. Специалистов искали по всей стране и даже
                    за рубежом ― кадровый голод был катастрофическим. Поэтому
                    быстро стало ясно: готовых профессионалов мало, нужно
                    растить своих.
                  </p>
                ) : (
                  <p className={styles.storyStage__text}>
                    Задачи выходили за рамки одного производства: офис компании
                    <br />
                    в Ярославле, завод «ОРТАТ» в Костромской области, площадка
                    <br />в Ростове. Специалистов искали по всей стране и даже
                    за рубежом ― кадровый голод был катастрофическим. Поэтому
                    быстро стало ясно: готовых профессионалов мало, нужно
                    растить своих.
                  </p>
                )}
              </div>
            </div>

            <div className={styles.storyStage__cta}>
              <h3 className={styles.storyStage__ctaTitle}>
                Нажми, если готов начать с нуля
              </h3>
              <Link to="/vacancies" className={styles.storyStage__ctaButton}>
                Начать с нуля
              </Link>
            </div>
          </div>
        </section>

        <section className={styles.storyStage} data-stage="1">
          <div className={clsx("container", styles.storyStage__inner)}>
            <div>
              <StoryDate
                className={styles.storyStage__date}
                date="2014 год"
                title={
                  "От поиска партнеров\nдо уникальной\nсистемы подготовки\nкадров"
                }
                color="green-light-secondary"
              />
              <p className={styles.storyStage__intro} data-animate="fade-in-up">
                {isMobile ? (
                  <>
                    В 2014 году я возглавила отдел подготовки кадров. Главное
                    направление ― работа <br />с молодежью и учебными
                    заведениями.
                    <br />
                    <br />
                    Мы начинали с вузов и колледжей Ярославля, потом вышли на
                    всю страну. Подписывали соглашения, запускали
                    образовательные программы, конкурсы <br />и стажировки,
                    назначали стипендии.
                    <br />
                    Очень быстро у нас появилось более <br />
                    50 образовательных партнеров
                    <br />
                    <br />
                    Сейчас всё это кажется обычной историей, многие крупные
                    компании занимаются подготовкой кадров похожим образом, но
                    на тот момент наша компания была первопроходцем.
                  </>
                ) : (
                  <>
                    В 2014 году я возглавила отдел подготовки кадров. Главное
                    направление ― работа с молодежью и учебными заведениями.
                    <br />
                    <br />
                    Мы начинали с вузов и колледжей Ярославля, потом вышли на
                    всю страну. Подписывали соглашения, запускали
                    образовательные программы, конкурсы и стажировки, назначали
                    стипендии.
                    <br />
                    Очень быстро у нас появилось более 50 образовательных
                    партнеров
                    <br />
                    <br />
                    Сейчас всё это кажется обычной историей, многие крупные
                    компании занимаются подготовкой кадров похожим образом,
                    <br />
                    но на тот момент наша компания была первопроходцем.
                  </>
                )}
              </p>
            </div>

            <Quote
              className={styles.storyStage__quote}
              text={[
                "Горжусь тем, что Р-Фарм был флагманом",
                "в области подготовки кадров. Приятно, что",
                "я имею к этому непосредственное отношение",
              ]}
              textMobile={[
                "Горжусь тем, что Р-Фарм",
                "был флагманом в области",
                "подготовки кадров. Приятно,",
                "что я имею к этому",
                "непосредственное",
                "отношение",
              ]}
              color="dark"
            />

            <div
              className={styles.storyStage__detail}
              data-animate="fade-in-up"
            >
              {!isMobile && (
                <img
                  className={styles.storyStage__img2}
                  src={`${path}/img/ekaterina-illustration-2.webp`}
                  alt="иллюстрация"
                />
              )}
              <div className={styles.storyStage__description2}>
                <h3 className={styles.storyStage__title}>
                  Партнёрства с вузами и новые <br />
                  форматы обучения
                </h3>

                <p className={styles.storyStage__text}>
                  {isMobile ? (
                    <>
                      Мы участвовали в федеральных инициативах, в том числе в
                      WorldSkills. <br />В 2019 году студентка Настя Камнева,
                      подготовленная в Р-Фарм, выиграла чемпионат мира в
                      Казани
                      <br /> по лабораторно-химическому анализу. Сейчас она
                      работает в нашем R&D.
                    </>
                  ) : (
                    <>
                      Мы участвовали в федеральных инициативах, в том числе
                      <br />
                      в WorldSkills. В 2019 году студентка Настя Камнева,
                      подготовленная
                      <br />в Р-Фарм, выиграла чемпионат мира в Казани по
                      лабораторно-химическому анализу. Сейчас она работает в
                      нашем R&D.
                    </>
                  )}
                </p>
                <p className={styles.storyStage__text}>
                  {isMobile ? (
                    <>
                      Партнерских проектов с учебными заведениями появилось
                      очень много.
                      <br />
                      Мы придумывали проекты, которые позволяли притронуться к
                      профессии руками. Например, мы создали тренинг-центр
                      «Биотехнологическое производство» на базе Ярославского
                      колледжа ― мини-завод для практики студентов.
                    </>
                  ) : (
                    <>
                      Партнерских проектов с учебными заведениями появилось
                      очень много. Мы придумывали проекты, которые позволяли
                      притронуться
                      <br />к профессии руками. Например, мы создали
                      тренинг-центр «Биотехнологическое производство» на базе
                      Ярославского колледжа ― мини-завод для практики студентов.
                    </>
                  )}
                </p>
                {isMobile && (
                  <img
                    className={styles.storyStage__img2}
                    src={`${path}/img/ekaterina-illustration-2.webp`}
                    alt="иллюстрация"
                  />
                )}
                {isMobile ? (
                  <>
                    <p className={styles.storyStage__text}>
                      Позже поняли, что профориентацию нужно начинать ещё в
                      школе. <br />
                      Так появился проект «ФармСтарт» <br />и «ФармСмена» во
                      Всероссийском детском центре «Смена» под Анапой.
                    </p>
                    <p className={styles.storyStage__text}>
                      Там работает наша лаборатория, где мы круглый год знакомим
                      ребят
                      <br />с профессиями фарминдустрии.
                    </p>
                    <p className={styles.storyStage__text}>
                      Если дети, с которыми мы начинали работать в школе, а
                      затем продолжили <br />в колледжах и вузах, приходят потом
                      <br />в Р-Фарм, ― это значит, что мы всё делаем
                      правильно. А таких историй уже <br />
                      немало.
                    </p>
                  </>
                ) : (
                  <>
                    <p className={styles.storyStage__text}>
                      Позже поняли, что профориентацию нужно начинать ещё в
                      школе. Так появился проект «ФармСтарт» и «ФармСмена»{" "}
                      <br />
                      во Всероссийском детском центре «Смена» под Анапой.
                    </p>
                    <p className={styles.storyStage__text}>
                      Там работает наша лаборатория, где мы круглый год знакомим
                      ребят с профессиями фарминдустрии.
                    </p>
                    <p className={styles.storyStage__text}>
                      Если дети, с которыми мы начинали работать в школе, а
                      затем продолжили в колледжах и вузах, приходят потом в
                      Р-Фарм, ― это значит, что мы всё делаем правильно. А
                      таких историй уже немало.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className={styles.storyStage} data-stage="2">
          <div className={clsx("container", styles.storyStage__inner)}>
            <div>
              <StoryDate
                className={styles.storyStage__date}
                date="2024 год"
                title={"От отдела до\nдепартамента"}
                color="green-light-secondary"
              />

              {isMobile ? (
                <p
                  className={styles.storyStage__intro}
                  data-animate="fade-in-up"
                >
                  В апреле 2024 года я стала директором департамента подготовки
                  кадров. Отдел вырос, появились руководители направлений.
                  <br />
                  <br />
                  Я часто выступаю идейным вдохновителем, но без команды я бы
                  <br /> не справилась. В департаменте <br />
                  работают энтузиасты, в основном молодежь, они заряжают
                  энергией и идеями. Вместе мы рассказываем студентам и
                  школьникам о профессиях,
                  <br /> даём попробовать работу руками, влюбляем в
                  производство. Недавно запустили обучение с VR-технологиями.
                  <br />
                  <br />
                  Мы постоянно сталкиваемся с новыми вызовами. Например, во
                  время пандемии...
                  <br />
                  <br />
                  Но мы справились, набрали большую группу студентов из
                  действующих партнерских проектов и за три месяца обучили их
                  работе <br />
                  на биотехнологическом производстве.
                </p>
              ) : (
                <p
                  className={styles.storyStage__intro}
                  data-animate="fade-in-up"
                >
                  В апреле 2024 года я стала директором департамента подготовки
                  кадров. Отдел вырос, появились руководители направлений.
                  <br />
                  <br />
                  Я часто выступаю идейным вдохновителем, но без команды я бы
                  <br /> не справилась. В департаменте работают энтузиасты, в
                  основном молодежь, они заряжают энергией и идеями. <br />
                  Вместе мы рассказываем студентам и школьникам о профессиях,
                  <br /> даём попробовать работу руками, влюбляем в
                  производство.
                  <br />
                  Недавно запустили обучение с VR-технологиями.
                  <br />
                  <br />
                  Мы постоянно сталкиваемся с новыми вызовами. Например,
                  <br /> во время пандемии...
                  <br />
                  <br />
                  Но мы справились, набрали большую группу студентов <br />
                  из действующих партнерских проектов и за три месяца обучили их
                  работе на биотехнологическом производстве.
                </p>
              )}
            </div>

            <Quote
              className={styles.storyStage__quote}
              text={[
                "Ценность Р-Фарм в том, что здесь не получится",
                "топтаться на месте, слишком быстро",
                "развивается группа компаний. При этом",
                "карьерный путь может быть любым ―",
                "горизонтальным или вертикальным",
              ]}
              textMobile={[
                "Ценность Р-Фарм в том, что",
                "здесь не получится топтаться",
                "на месте, слишком быстро",
                "развивается группа компаний.",
                "При этом карьерный путь",
                "может быть любым ―",
                "горизонтальным или",
                "вертикальным",
              ]}
              color="dark"
            />

            <div
              className={styles.storyStage__detail}
              data-animate={"fade-in-up"}
            >
              {!isMobile && (
                <img
                  className={styles.storyStage__img3}
                  src={`${path}/img/ekaterina-illustration-3.webp`}
                  alt="иллюстрация"
                />
              )}
              <div className={styles.storyStage__description3}>
                <h3 className={styles.storyStage__title}>
                  {isMobile ? (
                    <>
                      Команда энтузиастов и движение
                      <br /> вперёд
                    </>
                  ) : (
                    <>Команда энтузиастов и движение вперёд</>
                  )}
                </h3>

                {isMobile ? (
                  <p className={styles.storyStage__text}>
                    И мне всё ещё есть куда расти: я хочу стать экспертом
                    международного уровня в сфере подготовки кадров. <br />
                    Важно не успокаиваться, продолжать развиваться.
                  </p>
                ) : (
                  <p className={styles.storyStage__text}>
                    И мне всё ещё есть куда расти: я хочу стать экспертом
                    международного уровня в сфере подготовки кадров. Важно
                    <br />
                    не успокаиваться, продолжать развиваться.
                  </p>
                )}

                <p className={styles.storyStage__text}>
                  Думать о том, что сделать сегодня, чтобы это было актуально
                  послезавтра.
                </p>

                {isMobile && (
                  <img
                    className={styles.storyStage__img3}
                    src={`${path}/img/ekaterina-illustration-3.webp`}
                    alt="иллюстрация"
                  />
                )}
              </div>
            </div>

            <Test
              className={styles.storyStage__test}
              question="Как вы думаете, что я считаю главным своим достижением в Р-Фарм?"
              answers={[
                "Личный карьерный рост до директора департамента",
                "Формирование команды единомышленников",
                "Запуск VR-программы обучения",
              ]}
              rightAnswer={2}
              resultTitles={["Не совсем так", "Верно!", "Не совсем так"]}
              resultText={[
                [
                  "Я действительно горжусь своим карьерным ростом и внедрением новых технологий, но самое важное для меня — команда. Без этих людей ничего бы не получилось. Все наши проекты, идеи и достижения стали возможны только потому, что мы работаем вместе и вдохновляем друг друга",
                  "Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться.",
                ],
                [
                  "Моё главное достижение — это команда. В Р-Фарм мы сделали многое, но основа всех успехов — люди, которые верят в общее дело и не боятся идти вперёд. Я часто выступаю идейным вдохновителем, но без команды ничего бы не получилось.",
                  "Наши ответы совпали! И я была бы рада поработать с вами.",
                ],
                [
                  "Да, запуск VR-программы — важная часть нашей работы и пример того, как мы внедряем современные технологии. Но главное моё достижение не в этом. Всё, что мы создаём — результат команды, людей, которые верят в общее дело и растут вместе со мной. Без этой команды ни один проект, даже самый технологичный, не имел бы смысла.",
                  "Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться.",
                ],
              ]}
              img="ekaterina-test-1"
              color="green-secondary"
            />
          </div>
        </section>

        <div className={styles.storyFinal}>
          <div className="container">
            <Conclusion
              className={styles.storyFinal__conclusion}
              img="ekaterina-img"
              text={
                isMobile
                  ? [
                      "Р-Фарм дает не только операционную и творческую свободу в работе, но и на глобальном уровне — за пределами компании.",
                      "Я стояла у истоков первого производственного проекта \nи участвовала в создании системы подготовки кадров для группы компаний. Это очень интересный \nи ценный опыт. Расскажу о нем подробнее.",
                    ]
                  : [
                      "Р-Фарм дает не только операционную и творческую свободу \nв работе, но и на глобальном уровне — за пределами компании.",
                      "Я стояла у истоков первого производственного проекта \nи участвовала в создании системы подготовки кадров для группы компаний. Это очень интересный и ценный опыт. Расскажу о нем подробнее.",
                    ]
              }
              use="ekaterina"
            >
              <Figure
                className={styles.storyFinal__conclusionElement_1}
                color="green-dark-secondary"
                form="rect"
              >
                Екатерина Репкина
              </Figure>
              <Figure
                className={styles.storyFinal__conclusionElement_2}
                bg={"green-light-triangle.svg"}
                form="circle"
              />
            </Conclusion>

            <Invite
              className={styles.storyFinal__invite}
              color="green_secondary"
              title={"Если вы тоже\nцените свободу,"}
              desc={
                "не боитесь проявлять инициативу и ошибаться, умеете отстаивать свои решения и мечтать, приходите в Р-Фарм."
              }
              data-animate="fade-in-up"
            />

            <MoreStory
              className={styles.storyFinal__more}
              color="green_secondary"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StoryEkaterina;
